<template>
  <div class="paused-output">
    <Text
      as="p"
      class="message"
      :skeleton="props.skeleton"
      :skeleton-breakpoints="{ default: '680px', tablet: '360px', mobile: '320px' }"
      data-test="paused-experience-message"
    >
      {{ pausedMessage }}

      <router-link
        class="link"
        :to="link"
      >
        {{ t('linkText') }}
      </router-link>
    </Text>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from '@experience/i18n';
  import ru from '../../i18n/ru.json';
  import { withMfsDomain } from '@/shared/lib/withMfsDomain';
  import { Text } from '@/shared/ui/text';

  const props = defineProps<{ message: string; skeleton?: boolean }>();

  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  const pausedMessage = computed(() => t('pausedMessage', { message: props.message }));
  const route = useRoute();

  const link = computed(() => {
    const { citySlug, country, regionSlug } = route.params;
    if (citySlug) {
      return withMfsDomain(`/experience/${route.params.citySlug}/`);
    }

    const regionSlugTitle = regionSlug ? `${regionSlug}/` : '';

    if (country) {
      return withMfsDomain(`/tours/${country}/${regionSlugTitle}`);
    }

    return '';
  });
</script>

<style src="./message.scss" scoped lang="scss" />
<style scoped lang="scss">
  @use '@experience/shared/dist/assets/adaptivity' as adaptivity;

  .paused-output {
    align-self: start;
    margin-top: 32px;

    .message {
      text-align: start;
    }

    .link {
      display: inline-block;
      color: var(--alias-color-link-default);
      text-decoration: none;

      &:hover {
        color: var(--alias-color-link-default-hovered);
      }
    }
  }
</style>
